/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntireOverviewModel } from '../../models/entire-overview-model';

export interface GetEntireOverivew$Params {
  systemSerialNumber: string;
  systemMaterialNumber: number;
  modalityId: number;
  startDateTime?: number;
  endDateTime?: number;
  isCustomDateTime?: boolean;
}

export function getEntireOverivew(http: HttpClient, rootUrl: string, params: GetEntireOverivew$Params, context?: HttpContext): Observable<StrictHttpResponse<EntireOverviewModel>> {
  const rb = new RequestBuilder(rootUrl, getEntireOverivew.PATH, 'get');
  if (params) {
    rb.path('systemSerialNumber', params.systemSerialNumber, {});
    rb.path('systemMaterialNumber', params.systemMaterialNumber, {});
    rb.path('modalityId', params.modalityId, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('isCustomDateTime', params.isCustomDateTime, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EntireOverviewModel>;
    })
  );
}

/**
 * Custom addition for our mocking infrastructure
 * in case this ever causes problems we can also keep a dictionary that maps operations to paths on the side
 **/
getEntireOverivew.PATH = '/api/systemoverview/entireoverview/{systemSerialNumber}/{systemMaterialNumber}/{modalityId}';
getEntireOverivew.METHOD = 'get';

/**
 * we annotate each endpoint with a root rootUrl
 * this is because we have multiple APIs so we need to know which api fn belongs to
 * so we can map it depending on the env. rootUrl is picked from the first server listed in the APISpec
 **/
getEntireOverivew.ROOTURL = '/portal';
